<template>
  <div style="overflow-x: auto; overflow-y: hidden">
    <div
      v-if="generics && generics.length > 0"
      :style="{ width: generics.length * ((size == 'big' ? 300 : 200) + 15) + 'px' }"
    >
      <div
        style="margin: 0; padding: 0; display: flex"
        :style="{
          'padding-bottom': size == 'small' ? '0px' : '25px',
          'justify-content': align == 'left' ? 'flex-start' : 'flex-end',
        }"
      >
        <template v-for="(generic, index) in generics">
          <generic-viewer-item
            :ratio="ratio"
            :generic="generic"
            :key="'generic_' + index"
            :size="size"
          ></generic-viewer-item>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import GenericViewerItem from './GenericViewerItem'
export default {
  props: {
    value: [Object, String, Array],
    size: {
      type: String,
      default: 'big',
    },
    align: {
      default: 'left',
    },
    ratio: {
      default: 'square',
    },
  },
  components: {
    GenericViewerItem,
  },
  computed: {
    genericsLength: function () {
      var count = 0
      return this.generics.length
    },
  },
  data: function () {
    return {
      generics: this.value,
    }
  },
  watch: {
    value: function () {
      this.generics = this.value
    },
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/GenericViewer.vue